import type { ReactNode } from 'react';
import React from 'react';

import Hero from 'Components/StaticPages/ProductPageComponents/Hero/Hero';

import { MOTORWAY_PAY_HERO_SECTION_ID } from '../DiscoverMWPay.consts';

import heroAvif from './images/pay-hero.avif';
import heroPng from './images/pay-hero.png';
import heroWebp from './images/pay-hero.webp';

export type HeroSectionProps = {
	actions: ReactNode;
	hasStickyButtons: boolean;
	isPaymentsEnrolled?: boolean;
	ref: React.Ref<HTMLDivElement>;
};

export const HeroSection = React.forwardRef<HTMLDivElement, HeroSectionProps>((props, ref) => {
	const { actions, hasStickyButtons, isPaymentsEnrolled } = props;

	return (
		<Hero
			ref={ref}
			buttons={isPaymentsEnrolled ? <div data-sticky={hasStickyButtons ? 'true' : undefined}>{actions}</div> : null}
			image={{
				avif: heroAvif.src,
				height: heroPng.height,
				png: heroPng.src,
				webp: heroWebp.src,
				width: heroPng.width,
			}}
			subtitle="Transfer funds in real time or top up in advance, confirm payment with one click and Motorway Pay will manage seller and finance company payments for you."
			title={
				<>
					<strong id={MOTORWAY_PAY_HERO_SECTION_ID}>Fast, simple and</strong> secure payments
				</>
			}
		/>
	);
});
